import { render, staticRenderFns } from "./BrandCenters.vue?vue&type=template&id=65499c86&scoped=true&"
import script from "./BrandCenters.vue?vue&type=script&lang=js&"
export * from "./BrandCenters.vue?vue&type=script&lang=js&"
import style0 from "./BrandCenters.vue?vue&type=style&index=0&id=65499c86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65499c86",
  null
  
)

export default component.exports